var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641,
    y: 394,
    width: 25,
    height: 26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 395,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 395,
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642,
    y: 395,
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-641 -394)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M652.502 416.1C652.502 416.927 653.173 417.598 654 417.598 654.827 417.598 655.498 416.927 655.498 416.1M655.161 397.6C658.509 398.164 660.961 401.062 660.957 404.455L660.957 410.081C660.957 411.146 661.178 412.201 661.607 413.189L661.778 413.556 662.352 414.702C662.488 414.974 662.378 415.305 662.105 415.442 662.029 415.48 661.944 415.5 661.859 415.5L646.141 415.5C645.837 415.5 645.59 415.253 645.59 414.949 645.59 414.863 645.61 414.778 645.648 414.702L646.222 413.556C646.76 412.475 647.041 411.286 647.041 410.08L647.041 404.454C647.029 401.057 649.487 398.153 652.843 397.6 653.608 397.467 654.395 397.467 655.161 397.6ZM654.955 398.782C654.325 398.673 653.678 398.673 653.038 398.784 650.343 399.228 648.348 401.506 648.245 404.214L648.241 404.454 648.241 410.08C648.241 411.355 647.969 412.615 647.445 413.778L647.295 414.093 647.191 414.3 660.809 414.3 660.691 414.063 660.507 413.668C660.061 412.642 659.81 411.553 659.764 410.449L659.757 410.081 659.757 404.454C659.76 401.728 657.847 399.387 655.197 398.828L654.955 398.782Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.0d65b0bedf9b820b0c99fa1314272766.svg";
export { ForwardRef as ReactComponent };